import userflow from 'userflow.js';

import type { User } from './types';

export default class Userflow {
  static async init(currentUser: User, userflowToken: string) {
    userflow.init(userflowToken);
    await userflow.identify(currentUser.email, {
      name: currentUser.firstname + ' ' + currentUser.lastname,
      email: currentUser.email,
      signed_up_at: currentUser.last_logged_in
        ? currentUser.last_logged_in
        : new Date().toISOString(),
      customerId: currentUser.instance.customer_id,
      instanceId: currentUser.instance.instance_id,
      productId: currentUser.instance.product_id,
      productSku: currentUser.instance.product_sku,
      allowedOperations: currentUser.instance.operations.map(operation => operation.name),
    });
  }
}
